import './home.css';
import {initSimpleSlider} from '../shared/sliders';

initSimpleSlider('#flexslider-18');
